<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '500px' }"
  (onHide)="closeDialog()"
>
  <ng-template pTemplate="header">
    <div class="w-100 text-center">
      <span class="h3 fw-bold">{{ title }}</span>
    </div>
  </ng-template>

  <div class="px-3">
    <div
      class="d-flex justify-content-between align-items-center py-2 border-bottom"
      *ngFor="let item of data"
    >
      <div class="fw-bold text-dark">{{ item.key }}</div>
      <div class="text-muted">{{ item.value }}</div>
    </div>
  </div>

  <div
    class="text-center py-4 px-3"
    *ngIf="!readOnly"
  >
    <div class="h5 fw-bold mb-1">Do you really want to reject the transaction?</div>
  </div>

  <div class="px-3">
    <label class="form-label fw-bold">
      {{ readOnly ? 'Remarks' : 'Enter Remarks' }}
      <span
        *ngIf="!readOnly && remarksRequired"
        class="text-danger"
      >
        *
      </span>
    </label>
    <textarea
      class="form-control"
      [(ngModel)]="remarks"
      (ngModelChange)="onRemarksChange($event)"
      (blur)="onRemarksBlur()"
      [placeholder]="readOnly ? '' : 'Enter remarks'"
      [readonly]="readOnly"
      [maxlength]="remarksMaxLength"
      [style]="
        readOnly ? 'text-align: center; font-size: 1.5rem; display: flex; align-items: center; padding-top: 35px;' : ''
      "
      rows="4"
    ></textarea>
    <small
      *ngIf="shouldShowRemarksError()"
      class="text-danger"
    >
      {{ getRemarksErrorMessage() }}
    </small>
    <small
      *ngIf="!readOnly"
      class="text-muted d-block text-end"
    >
      {{ remarks.length }}/{{ remarksMaxLength }}
    </small>
  </div>

  <ng-template pTemplate="footer">
    <hr />
    <div class="d-flex justify-content-center gap-2">
      <button
        class="btn btn-outline-secondary"
        [disabled]="isLoading"
        (click)="closeDialog()"
      >
        {{ readOnly ? 'Close' : 'Back' }}
      </button>
      <button
        *ngIf="!readOnly"
        class="btn btn-danger"
        [disabled]="isRejectDisabled()"
        (click)="onReject()"
      >
        <span
          *ngIf="isLoading"
          class="spinner-border spinner-border-sm me-1"
        ></span>
        Reject
      </button>
    </div>
  </ng-template>
</p-dialog>
